export const getProvinceCL = () =>{
  const response = [
    {
      "code": "San",
      "cities": [
        {
          "code": "San194",
          "description": "Alto Jahuel"
        },
        {
          "code": "San191",
          "description": "Batuco"
        },
        {
          "code": "San193",
          "description": "Buin"
        },
        {
          "code": "San198",
          "description": "Calera de Tango"
        },
        {
          "code": "San189",
          "description": "Colina"
        },
        {
          "code": "San197",
          "description": "Curacaví"
        },
        {
          "code": "San200",
          "description": "El Monte"
        },
        {
          "code": "San201",
          "description": "Isla de Maipo"
        },
        {
          "code": "San190",
          "description": "Lampa"
        },
        {
          "code": "San195",
          "description": "Melipilla"
        },
        {
          "code": "San196",
          "description": "Paine"
        },
        {
          "code": "San202",
          "description": "Peñaflor"
        },
        {
          "code": "San188",
          "description": "San José de Maipo"
        },
        {
          "code": "San187",
          "description": "Santiago"
        },
        {
          "code": "San199",
          "description": "Talagante"
        },
        {
          "code": "San192",
          "description": "Tiltil"
        }
      ],
      "description": "Región Metropolitana de Santiago"
    },
    {
      "code": "Ari",
      "cities": [
        {
          "code": "Ari001",
          "description": "Arica"
        },
        {
          "code": "Ari002",
          "description": "Putre"
        }
      ],
      "description": "Región de Arica y Parinacota"
    },
    {
      "code": "Tar",
      "cities": [
        {
          "code": "Tar004",
          "description": "Alto Hospicio"
        },
        {
          "code": "Tar003",
          "description": "Iquique"
        },
        {
          "code": "Tar005",
          "description": "Pozo Almonte"
        }
      ],
      "description": "Región de Tarapacá"
    },
    {
      "code": "Ant",
      "cities": [
        {
          "code": "Ant006",
          "description": "Antofagasta"
        },
        {
          "code": "Ant007",
          "description": "Calama"
        },
        {
          "code": "Ant011",
          "description": "María Elena"
        },
        {
          "code": "Ant010",
          "description": "Mejillones"
        },
        {
          "code": "Ant009",
          "description": "Taltal"
        },
        {
          "code": "Ant008",
          "description": "Tocopilla"
        }
      ],
      "description": "Región de Antofagasta"
    },
    {
      "code": "Ata",
      "cities": [
        {
          "code": "Ata013",
          "description": "Caldera"
        },
        {
          "code": "Ata015",
          "description": "Chañaral"
        },
        {
          "code": "Ata012",
          "description": "Copiapo"
        },
        {
          "code": "Ata016",
          "description": "Diego de Almagro"
        },
        {
          "code": "Ata017",
          "description": "El Salvador"
        },
        {
          "code": "Ata019",
          "description": "Huasco"
        },
        {
          "code": "Ata014",
          "description": "Tierra Amarilla"
        },
        {
          "code": "Ata018",
          "description": "Vallenar"
        }
      ],
      "description": "Región de Atacama"
    },
    {
      "code": "Coq",
      "cities": [
        {
          "code": "Coq023",
          "description": "Andacollo"
        },
        {
          "code": "Coq029",
          "description": "Combarbalá"
        },
        {
          "code": "Coq021",
          "description": "Coquimbo"
        },
        {
          "code": "Coq031",
          "description": "El Palqui"
        },
        {
          "code": "Coq025",
          "description": "Illapel"
        },
        {
          "code": "Coq020",
          "description": "La Serena"
        },
        {
          "code": "Coq026",
          "description": "Los Vilos"
        },
        {
          "code": "Coq030",
          "description": "Monte Patria"
        },
        {
          "code": "Coq028",
          "description": "Ovalle"
        },
        {
          "code": "Coq022",
          "description": "Punitaqui"
        },
        {
          "code": "Coq027",
          "description": "Salamanca"
        },
        {
          "code": "Coq024",
          "description": "Vicuña "
        }
      ],
      "description": "Región de Coquimbo"
    },
    {
      "code": "Val",
      "cities": [
        {
          "code": "Val059",
          "description": "Algarrobo"
        },
        {
          "code": "Val054",
          "description": "Cabildo"
        },
        {
          "code": "Val050",
          "description": "Calle Larga"
        },
        {
          "code": "Val040",
          "description": "Cartagena"
        },
        {
          "code": "Val046",
          "description": "Casa Blanca"
        },
        {
          "code": "Val062",
          "description": "Catemu"
        },
        {
          "code": "Val033",
          "description": "Con Con"
        },
        {
          "code": "Val057",
          "description": "El Melón"
        },
        {
          "code": "Val060",
          "description": "El Quisco"
        },
        {
          "code": "Val061",
          "description": "El Tabo"
        },
        {
          "code": "Val042",
          "description": "Hijuelas"
        },
        {
          "code": "Val043",
          "description": "La Calera"
        },
        {
          "code": "Val044",
          "description": "La Cruz"
        },
        {
          "code": "Val053",
          "description": "La Ligua"
        },
        {
          "code": "Val047",
          "description": "Las Ventanas"
        },
        {
          "code": "Val055",
          "description": "Limache"
        },
        {
          "code": "Val063",
          "description": "Llaillay"
        },
        {
          "code": "Val049",
          "description": "Los Andes"
        },
        {
          "code": "Val056",
          "description": "Nogales"
        },
        {
          "code": "Val058",
          "description": "Olmué"
        },
        {
          "code": "Val037",
          "description": "Placilla de Peñuelas"
        },
        {
          "code": "Val064",
          "description": "Putaendo"
        },
        {
          "code": "Val041",
          "description": "Quillota"
        },
        {
          "code": "Val036",
          "description": "Quilpué"
        },
        {
          "code": "Val048",
          "description": "Quintero"
        },
        {
          "code": "Val051",
          "description": "Rinconada"
        },
        {
          "code": "Val038",
          "description": "San Antonio"
        },
        {
          "code": "Val052",
          "description": "San Esteban"
        },
        {
          "code": "Val045",
          "description": "San Felipe"
        },
        {
          "code": "Val066",
          "description": "Santa María"
        },
        {
          "code": "Val039",
          "description": "Santo Domingo"
        },
        {
          "code": "Val032",
          "description": "Valparaíso"
        },
        {
          "code": "Val034",
          "description": "Villa Alemana"
        },
        {
          "code": "Val065",
          "description": "Villa los Almendros"
        },
        {
          "code": "Val035",
          "description": "Viña del Mar"
        }
      ],
      "description": "Región de Valparíso"
    },
    {
      "code": "Ohi",
      "cities": [
        {
          "code": "Ohi084",
          "description": "Chimbarongo"
        },
        {
          "code": "Ohi070",
          "description": "Codegua"
        },
        {
          "code": "Ohi071",
          "description": "Doñihue"
        },
        {
          "code": "Ohi073",
          "description": "Graneros"
        },
        {
          "code": "Ohi069",
          "description": "Gultro"
        },
        {
          "code": "Ohi074",
          "description": "Las Cabras"
        },
        {
          "code": "Ohi072",
          "description": "Lo Miranda"
        },
        {
          "code": "Ohi068",
          "description": "Machalí"
        },
        {
          "code": "Ohi085",
          "description": "Nancagua"
        },
        {
          "code": "Ohi086",
          "description": "Palmilla"
        },
        {
          "code": "Ohi076",
          "description": "Peumo"
        },
        {
          "code": "Ohi082",
          "description": "Pichilemu"
        },
        {
          "code": "Ohi077",
          "description": "Punta Diamante"
        },
        {
          "code": "Ohi078",
          "description": "Quinta de Tilcoco"
        },
        {
          "code": "Ohi067",
          "description": "Rancagua"
        },
        {
          "code": "Ohi079",
          "description": "Rengo"
        },
        {
          "code": "Ohi080",
          "description": "Requínoa"
        },
        {
          "code": "Ohi083",
          "description": "San Fernando"
        },
        {
          "code": "Ohi075",
          "description": "San Francisco de Mostazal"
        },
        {
          "code": "Ohi081",
          "description": "San Vicente de Tagua Tagua"
        },
        {
          "code": "Ohi087",
          "description": "Santa Cruz"
        }
      ],
      "description": "Región del Libertador General Bernardo O'Higgins"
    },
    {
      "code": "Mau",
      "cities": [
        {
          "code": "Mau093",
          "description": "Cauquenes"
        },
        {
          "code": "Mau091",
          "description": "Constitución"
        },
        {
          "code": "Mau089",
          "description": "Curicó"
        },
        {
          "code": "Mau094",
          "description": "Hualañé"
        },
        {
          "code": "Mau090",
          "description": "Linares"
        },
        {
          "code": "Mau097",
          "description": "Longaví"
        },
        {
          "code": "Mau095",
          "description": "Molina"
        },
        {
          "code": "Mau098",
          "description": "Parral"
        },
        {
          "code": "Mau092",
          "description": "San Clemente"
        },
        {
          "code": "Mau099",
          "description": "San Javier"
        },
        {
          "code": "Mau088",
          "description": "Talca"
        },
        {
          "code": "Mau096",
          "description": "Teno"
        },
        {
          "code": "Mau100",
          "description": "Villa Alegre"
        }
      ],
      "description": "Región del Maule"
    },
    {
      "code": "Ñub",
      "cities": [
        {
          "code": "Ñub103",
          "description": "Bulnes"
        },
        {
          "code": "Ñub101",
          "description": "Chillán"
        },
        {
          "code": "Ñub102",
          "description": "Chillán Viejo"
        },
        {
          "code": "Ñub104",
          "description": "Coelemu"
        },
        {
          "code": "Ñub105",
          "description": "Coihueco"
        },
        {
          "code": "Ñub106",
          "description": "Quillón"
        },
        {
          "code": "Ñub107",
          "description": "Quirihue"
        },
        {
          "code": "Ñub108",
          "description": "San Carlos"
        },
        {
          "code": "Ñub109",
          "description": "Yungay"
        }
      ],
      "description": "Región de Ñuble"
    },
    {
      "code": "Bio",
      "cities": [
        {
          "code": "Bio123",
          "description": "Arauco"
        },
        {
          "code": "Bio127",
          "description": "Cabrero"
        },
        {
          "code": "Bio124",
          "description": "Cañete"
        },
        {
          "code": "Bio112",
          "description": "Chiguayante"
        },
        {
          "code": "Bio110",
          "description": "Concepcíon"
        },
        {
          "code": "Bio113",
          "description": "Coronel"
        },
        {
          "code": "Bio125",
          "description": "Curanilahue"
        },
        {
          "code": "Bio118",
          "description": "Hualpén"
        },
        {
          "code": "Bio114",
          "description": "Hualqui"
        },
        {
          "code": "Bio134",
          "description": "Huépil"
        },
        {
          "code": "Bio129",
          "description": "La Laja"
        },
        {
          "code": "Bio122",
          "description": "Lebu"
        },
        {
          "code": "Bio126",
          "description": "Los Álamos"
        },
        {
          "code": "Bio121",
          "description": "Los Ángeles"
        },
        {
          "code": "Bio115",
          "description": "Lota"
        },
        {
          "code": "Bio128",
          "description": "Monte Águila"
        },
        {
          "code": "Bio131",
          "description": "Mulchén"
        },
        {
          "code": "Bio132",
          "description": "Nacimiento"
        },
        {
          "code": "Bio116",
          "description": "Penco"
        },
        {
          "code": "Bio119",
          "description": "San Pedro de La Paz"
        },
        {
          "code": "Bio130",
          "description": "San Rosendo"
        },
        {
          "code": "Bio133",
          "description": "Santa Bárbara"
        },
        {
          "code": "Bio120",
          "description": "Santa Juana"
        },
        {
          "code": "Bio111",
          "description": "Talcahuano"
        },
        {
          "code": "Bio117",
          "description": "Tomé"
        },
        {
          "code": "Bio135",
          "description": "Yumbel"
        }
      ],
      "description": "Región del BioBío"
    },
    {
      "code": "Ara",
      "cities": [
        {
          "code": "Ara149",
          "description": "Angol"
        },
        {
          "code": "Ara139",
          "description": "Carahue"
        },
        {
          "code": "Ara150",
          "description": "Collipulli"
        },
        {
          "code": "Ara140",
          "description": "Cunco"
        },
        {
          "code": "Ara151",
          "description": "Curacautín"
        },
        {
          "code": "Ara141",
          "description": "Freire"
        },
        {
          "code": "Ara142",
          "description": "Gorbea"
        },
        {
          "code": "Ara138",
          "description": "Labranza"
        },
        {
          "code": "Ara143",
          "description": "Lautaro"
        },
        {
          "code": "Ara144",
          "description": "Loncoche"
        },
        {
          "code": "Ara152",
          "description": "Melipeuco"
        },
        {
          "code": "Ara145",
          "description": "Nueva Imperial"
        },
        {
          "code": "Ara137",
          "description": "Padre las Casas"
        },
        {
          "code": "Ara146",
          "description": "Pitrufquén"
        },
        {
          "code": "Ara147",
          "description": "Pucón"
        },
        {
          "code": "Ara153",
          "description": "Purén"
        },
        {
          "code": "Ara154",
          "description": "Renaico"
        },
        {
          "code": "Ara136",
          "description": "Temuco"
        },
        {
          "code": "Ara155",
          "description": "Traiguén"
        },
        {
          "code": "Ara156",
          "description": "Victoria"
        },
        {
          "code": "Ara148",
          "description": "Villarica"
        }
      ],
      "description": "Región de la Araucanía"
    },
    {
      "code": "Rio",
      "cities": [
        {
          "code": "Rio158",
          "description": "Futrono"
        },
        {
          "code": "Rio159",
          "description": "La Unión"
        },
        {
          "code": "Rio160",
          "description": "Lanco"
        },
        {
          "code": "Rio161",
          "description": "Los Lagos"
        },
        {
          "code": "Rio163",
          "description": "Paillaco"
        },
        {
          "code": "Rio164",
          "description": "Panguipulli"
        },
        {
          "code": "Rio165",
          "description": "Río Bueno"
        },
        {
          "code": "Rio162",
          "description": "San José de la Mariquina"
        },
        {
          "code": "Rio157",
          "description": "Valdivia"
        }
      ],
      "description": "Región de Los Ríos"
    },
    {
      "code": "Lag",
      "cities": [
        {
          "code": "Lag174",
          "description": "Ancud"
        },
        {
          "code": "Lag168",
          "description": "Calbuco"
        },
        {
          "code": "Lag172",
          "description": "Castro"
        },
        {
          "code": "Lag169",
          "description": "Fresia"
        },
        {
          "code": "Lag170",
          "description": "Frutillar"
        },
        {
          "code": "Lag175",
          "description": "Llanquihue"
        },
        {
          "code": "Lag171",
          "description": "Los Muermos"
        },
        {
          "code": "Lag176",
          "description": "Osorno"
        },
        {
          "code": "Lag166",
          "description": "Puerto Montt"
        },
        {
          "code": "Lag167",
          "description": "Puerto Varas"
        },
        {
          "code": "Lag177",
          "description": "Purranque"
        },
        {
          "code": "Lag173",
          "description": "Quellón"
        },
        {
          "code": "Lag178",
          "description": "Río Negro"
        }
      ],
      "description": "Región de Los Lagos"
    },
    {
      "code": "Ays",
      "cities": [
        {
          "code": "Ays182",
          "description": "Balmaceda"
        },
        {
          "code": "Ays181",
          "description": "Chile Chico"
        },
        {
          "code": "Ays183",
          "description": "Cochrane"
        },
        {
          "code": "Ays179",
          "description": "Coyhaique"
        },
        {
          "code": "Ays180",
          "description": "Puerto Aysén"
        }
      ],
      "description": "Región de Aysén del General Carlos Ibáñez del Campo"
    },
    {
      "code": "Mag",
      "cities": [
        {
          "code": "Mag185",
          "description": "Puerto Natales"
        },
        {
          "code": "Mag186",
          "description": "Puerto Williams"
        },
        {
          "code": "Mag184",
          "description": "Punta Arenas"
        }
      ],
      "description": "Región de Magallanes y de la Antártica Chilena"
    }
  ];

  return response;
}

export const getProvinceAR = () =>{
    const response = [
        {
          "code": "0005",
          "cities": [
            {
              "code": "BUE",
              "description": "Ciudad de Buenos Aires"
            }
          ],
          "description": "Ciudad de Buenos Aires"
        },
        {
          "code": "0001",
          "cities": [
            {
              "code": "ING",
              "description": "Ago"
            },
            {
              "code": "B101",
              "description": "Azul"
            },
            {
              "code": "BHI",
              "description": "Bahía Blanca"
            },
            {
              "code": "B102",
              "description": "Balcarce"
            },
            {
              "code": "B103",
              "description": "Baradero"
            },
            {
              "code": "B104",
              "description": "Belen de Escobar"
            },
            {
              "code": "B105",
              "description": "Bella Vista"
            },
            {
              "code": "B106",
              "description": "Berisso"
            },
            {
              "code": "BO1",
              "description": "Bolívar"
            },
            {
              "code": "B107",
              "description": "Bragado"
            },
            {
              "code": "B108",
              "description": "Brandsen"
            },
            {
              "code": "B109",
              "description": "Buenos Aires"
            },
            {
              "code": "CP1",
              "description": "Campana"
            },
            {
              "code": "B110",
              "description": "Canuelas"
            },
            {
              "code": "B111",
              "description": "Capilla del Señor"
            },
            {
              "code": "B112",
              "description": "Carhué"
            },
            {
              "code": "CA6",
              "description": "Cariló"
            },
            {
              "code": "B113",
              "description": "Carmen De Areco"
            },
            {
              "code": "CPG",
              "description": "Carmen de Patagones"
            },
            {
              "code": "B114",
              "description": "Chacabuco"
            },
            {
              "code": "B115",
              "description": "Chapadmalal"
            },
            {
              "code": "CH7",
              "description": "Chascomus"
            },
            {
              "code": "B116",
              "description": "Chivilcoy"
            },
            {
              "code": "CL5",
              "description": "Claromeco"
            },
            {
              "code": "B117",
              "description": "Coronel Suárez"
            },
            {
              "code": "B118",
              "description": "Coronel Vidal"
            },
            {
              "code": "B119",
              "description": "Costa Azul"
            },
            {
              "code": "CE3",
              "description": "Costa del Este"
            },
            {
              "code": "B120",
              "description": "Dique Luján"
            },
            {
              "code": "B121",
              "description": "Dolores"
            },
            {
              "code": "B122",
              "description": "Duggan"
            },
            {
              "code": "B123",
              "description": "Ezeiza"
            },
            {
              "code": "B125",
              "description": "Florentino Ameghino"
            },
            {
              "code": "B126",
              "description": "Florida"
            },
            {
              "code": "B124",
              "description": "Fátima"
            },
            {
              "code": "B127",
              "description": "General Juan Madariaga"
            },
            {
              "code": "B128",
              "description": "General Pacheco"
            },
            {
              "code": "VGS",
              "description": "General Villega"
            },
            {
              "code": "B129",
              "description": "Guerrero"
            },
            {
              "code": "B130",
              "description": "Ituzaingo"
            },
            {
              "code": "JNI",
              "description": "Junin"
            },
            {
              "code": "LPG",
              "description": "La Plata"
            },
            {
              "code": "B131",
              "description": "La Reja"
            },
            {
              "code": "B132",
              "description": "Las Flores"
            },
            {
              "code": "LG1",
              "description": "Las Gaviotas"
            },
            {
              "code": "B133",
              "description": "Las Toninas"
            },
            {
              "code": "B134",
              "description": "Lincoln"
            },
            {
              "code": "B135",
              "description": "Lobos"
            },
            {
              "code": "B136",
              "description": "Loma Verde"
            },
            {
              "code": "CD3",
              "description": "Los Cardales"
            },
            {
              "code": "B137",
              "description": "Los Pinos"
            },
            {
              "code": "B138",
              "description": "Los Toldos"
            },
            {
              "code": "B139",
              "description": "Lujan"
            },
            {
              "code": "MA7",
              "description": "Mar Azul"
            },
            {
              "code": "MJ1",
              "description": "Mar de Ajo"
            },
            {
              "code": "B140",
              "description": "Mar de Cobo"
            },
            {
              "code": "MP0",
              "description": "Mar de las Pampas"
            },
            {
              "code": "MDQ",
              "description": "Mar del Plata"
            },
            {
              "code": "B141",
              "description": "Martínez"
            },
            {
              "code": "MDX",
              "description": "Mercedes"
            },
            {
              "code": "RLO",
              "description": "Merlo"
            },
            {
              "code": "MJR",
              "description": "Miramar"
            },
            {
              "code": "MO2",
              "description": "Monte"
            },
            {
              "code": "MH1",
              "description": "Monte Hermoso"
            },
            {
              "code": "B142",
              "description": "Moreno"
            },
            {
              "code": "NEC",
              "description": "Necochea"
            },
            {
              "code": "B143",
              "description": "Nueve de Julio"
            },
            {
              "code": "B144",
              "description": "Olavarría"
            },
            {
              "code": "B145",
              "description": "Olivos"
            },
            {
              "code": "B146",
              "description": "Open Door"
            },
            {
              "code": "OS0",
              "description": "Ostende"
            },
            {
              "code": "LPG",
              "description": "Otra ciudad"
            },
            {
              "code": "B147",
              "description": "Partido de Lobos"
            },
            {
              "code": "B148",
              "description": "Pedro Luro"
            },
            {
              "code": "PEH",
              "description": "Pehuajo"
            },
            {
              "code": "B149",
              "description": "Pergamino"
            },
            {
              "code": "PI5",
              "description": "Pilar"
            },
            {
              "code": "PI1",
              "description": "Pinamar"
            },
            {
              "code": "B150",
              "description": "Punta Alta"
            },
            {
              "code": "RA0",
              "description": "Ramallo"
            },
            {
              "code": "B151",
              "description": "Saladillo"
            },
            {
              "code": "B152",
              "description": "Salto"
            },
            {
              "code": "B153",
              "description": "San Andrés de Giles"
            },
            {
              "code": "SA5",
              "description": "San Antonio de Areco"
            },
            {
              "code": "SB1",
              "description": "San Bernardo"
            },
            {
              "code": "ST3",
              "description": "San Clemente del Tuyu"
            },
            {
              "code": "SF1",
              "description": "San Fernando"
            },
            {
              "code": "SI2",
              "description": "San Isidro"
            },
            {
              "code": "JT2",
              "description": "San Justo"
            },
            {
              "code": "B154",
              "description": "San Miguel del Monte"
            },
            {
              "code": "SN3",
              "description": "San Nicolas"
            },
            {
              "code": "SP1",
              "description": "San Pedro"
            },
            {
              "code": "B155",
              "description": "Santa Clara del Mar"
            },
            {
              "code": "SST",
              "description": "Santa Teresita"
            },
            {
              "code": "ST1",
              "description": "Santa Teresita"
            },
            {
              "code": "SV1",
              "description": "Sierra de la Ventana"
            },
            {
              "code": "B156",
              "description": "Sierra de los Padres"
            },
            {
              "code": "B157",
              "description": "Suipacha"
            },
            {
              "code": "TDL",
              "description": "Tandil"
            },
            {
              "code": "TI5",
              "description": "Tigre"
            },
            {
              "code": "B158",
              "description": "Tornquist"
            },
            {
              "code": "RTE",
              "description": "Trenque Lauquen"
            },
            {
              "code": "OYO",
              "description": "Tres Arroyos"
            },
            {
              "code": "VM1",
              "description": "Valeria del Mar"
            },
            {
              "code": "VL1",
              "description": "Vicente Lopez"
            },
            {
              "code": "B159",
              "description": "Villa Ciudad de America"
            },
            {
              "code": "VLG",
              "description": "Villa Gesell"
            },
            {
              "code": "B160",
              "description": "Villa Ventana"
            }
          ],
          "description": "Buenos Aires"
        },
        {
          "code": "0002",
          "cities": [
            {
              "code": "K161",
              "description": "Alumbrera"
            },
            {
              "code": "K162",
              "description": "Antofagasta de la Sierra"
            },
            {
              "code": "K163",
              "description": "Belén"
            },
            {
              "code": "CTC",
              "description": "Catamarca"
            },
            {
              "code": "K164",
              "description": "Copacabana"
            },
            {
              "code": "K165",
              "description": "El Peñón"
            },
            {
              "code": "K166",
              "description": "Fiambala"
            },
            {
              "code": "K167",
              "description": "Huillapima"
            },
            {
              "code": "K168",
              "description": "La Carrera"
            },
            {
              "code": "CTC",
              "description": "Otra ciudad"
            },
            {
              "code": "PG5",
              "description": "Puerta Grande"
            },
            {
              "code": "K169",
              "description": "Tinogasta"
            }
          ],
          "description": "Catamarca"
        },
        {
          "code": "0003",
          "cities": [
            {
              "code": "H170",
              "description": "Aviá Terai"
            },
            {
              "code": "CNT",
              "description": "Charata"
            },
            {
              "code": "RES",
              "description": "Otra ciudad"
            },
            {
              "code": "PRQ",
              "description": "Presidencia Roque Saenz Pena"
            },
            {
              "code": "RES",
              "description": "Resistencia"
            },
            {
              "code": "SZQ",
              "description": "Saenz Pena"
            },
            {
              "code": "H171",
              "description": "Villa Angela"
            }
          ],
          "description": "Chaco"
        },
        {
          "code": "0004",
          "cities": [
            {
              "code": "ARR",
              "description": "Alto Rio Senguerr"
            },
            {
              "code": "RNX",
              "description": "Camarones"
            },
            {
              "code": "U172",
              "description": "Cholila"
            },
            {
              "code": "OLN",
              "description": "Colonia Sarmien"
            },
            {
              "code": "CRD",
              "description": "Comodoro Rivadavia"
            },
            {
              "code": "U173",
              "description": "Corcovado"
            },
            {
              "code": "EMX",
              "description": "El Maiten"
            },
            {
              "code": "U174",
              "description": "Epuyén"
            },
            {
              "code": "EQS",
              "description": "Esquel"
            },
            {
              "code": "GM2",
              "description": "Gaiman"
            },
            {
              "code": "U175",
              "description": "Gobernador Costa"
            },
            {
              "code": "JSM",
              "description": "Jose de San Martin"
            },
            {
              "code": "LA7",
              "description": "Lago Puelo"
            },
            {
              "code": "RW1",
              "description": "Otra ciudad"
            },
            {
              "code": "PV2",
              "description": "Peninsula de Valdez"
            },
            {
              "code": "PU5",
              "description": "Playa Union"
            },
            {
              "code": "PMY",
              "description": "Puerto Madryn"
            },
            {
              "code": "PP1",
              "description": "Puerto Pirámides"
            },
            {
              "code": "PD1",
              "description": "Punta delgada"
            },
            {
              "code": "RW1",
              "description": "Rawson"
            },
            {
              "code": "ROY",
              "description": "Rio Mayo"
            },
            {
              "code": "U176",
              "description": "Río Pico"
            },
            {
              "code": "U177",
              "description": "Sarmiento"
            },
            {
              "code": "REL",
              "description": "Trelew"
            },
            {
              "code": "TV0",
              "description": "Trevelin"
            },
            {
              "code": "U178",
              "description": "Valdes"
            },
            {
              "code": "U179",
              "description": "Valle de Trevelin"
            }
          ],
          "description": "Chubut"
        },
        
        {
          "code": "0006",
          "cities": [
            {
              "code": "X180",
              "description": "Achiras"
            },
            {
              "code": "X181",
              "description": "Almafuerte"
            },
            {
              "code": "X182",
              "description": "Alpa Corral"
            },
            {
              "code": "AG2",
              "description": "Alta Gracia"
            },
            {
              "code": "X183",
              "description": "Alto Ongamira"
            },
            {
              "code": "X184",
              "description": "Arroyito"
            },
            {
              "code": "AS3",
              "description": "Ascochinga"
            },
            {
              "code": "X185",
              "description": "Bialet Massé"
            },
            {
              "code": "X186",
              "description": "Cabalango"
            },
            {
              "code": "CM2",
              "description": "Capilla del Monte"
            },
            {
              "code": "X187",
              "description": "Casa Grande"
            },
            {
              "code": "CO9",
              "description": "Cosquin"
            },
            {
              "code": "X188",
              "description": "Cruz de Cana"
            },
            {
              "code": "COR",
              "description": "Córdoba"
            },
            {
              "code": "X189",
              "description": "Embalse"
            },
            {
              "code": "HG1",
              "description": "Huerta Grande"
            },
            {
              "code": "JM1",
              "description": "Jesus Maria"
            },
            {
              "code": "X190",
              "description": "Jose de la Quintana"
            },
            {
              "code": "LCM",
              "description": "La Cumbre"
            },
            {
              "code": "LC1",
              "description": "La Cumbrecita"
            },
            {
              "code": "LF1",
              "description": "La Falda"
            },
            {
              "code": "X191",
              "description": "La Granja"
            },
            {
              "code": "X192",
              "description": "La Población"
            },
            {
              "code": "X193",
              "description": "La Serranita"
            },
            {
              "code": "X194",
              "description": "Laboulaye"
            },
            {
              "code": "X195",
              "description": "Las Rabona"
            },
            {
              "code": "X196",
              "description": "Loma Bola"
            },
            {
              "code": "X197",
              "description": "Los Hornillos"
            },
            {
              "code": "X198",
              "description": "Los Reartes"
            },
            {
              "code": "X199",
              "description": "Marcos Juárez"
            },
            {
              "code": "MC1",
              "description": "Mina Clavero"
            },
            {
              "code": "X200",
              "description": "Miramar"
            },
            {
              "code": "NN1",
              "description": "Nono"
            },
            {
              "code": "X201",
              "description": "Oncativo"
            },
            {
              "code": "COR",
              "description": "Otra ciudad"
            },
            {
              "code": "X202",
              "description": "Panaholma"
            },
            {
              "code": "X203",
              "description": "Potrero de Garay"
            },
            {
              "code": "RC0",
              "description": "Río Ceballos"
            },
            {
              "code": "RC2",
              "description": "Río Ceballos"
            },
            {
              "code": "RCU",
              "description": "Río Cuarto"
            },
            {
              "code": "X204",
              "description": "Río Tercero"
            },
            {
              "code": "X205",
              "description": "Salsipuedes"
            },
            {
              "code": "X206",
              "description": "San Antonio de Arredondo"
            },
            {
              "code": "X207",
              "description": "San Marcos Sierras"
            },
            {
              "code": "SR3",
              "description": "Santa Rosa de Calamuchita"
            },
            {
              "code": "X208",
              "description": "Sinsacate"
            },
            {
              "code": "X209",
              "description": "Taninga"
            },
            {
              "code": "TA7",
              "description": "Tanti"
            },
            {
              "code": "TR3",
              "description": "Traslasierra"
            },
            {
              "code": "X210",
              "description": "Unquillo"
            },
            {
              "code": "CT2",
              "description": "Valle de Calamuchita"
            },
            {
              "code": "X211",
              "description": "Valle de Paravachasca"
            },
            {
              "code": "X212",
              "description": "Valle de Punilla"
            },
            {
              "code": "X213",
              "description": "Valle Hermoso"
            },
            {
              "code": "X214",
              "description": "Villa Berne"
            },
            {
              "code": "VC1",
              "description": "Villa Carlos Paz"
            },
            {
              "code": "X215",
              "description": "Villa Ciudad Parque"
            },
            {
              "code": "VC2",
              "description": "Villa Cura Brochero"
            },
            {
              "code": "X216",
              "description": "Villa de Las Rosas"
            },
            {
              "code": "X217",
              "description": "Villa Del Dique"
            },
            {
              "code": "X218",
              "description": "Villa del Totoral"
            },
            {
              "code": "VDR",
              "description": "Villa Dolores"
            },
            {
              "code": "VG0",
              "description": "Villa General Belgrano"
            },
            {
              "code": "X219",
              "description": "Villa Giardino"
            },
            {
              "code": "X220",
              "description": "Villa Icho Cruz"
            },
            {
              "code": "X221",
              "description": "Villa Independencia"
            },
            {
              "code": "VS1",
              "description": "Villa La Serranita"
            },
            {
              "code": "X222",
              "description": "Villa Los Molinos"
            },
            {
              "code": "X223",
              "description": "Villa Maria"
            },
            {
              "code": "X224",
              "description": "Villa Parque Síquiman"
            },
            {
              "code": "X225",
              "description": "Villa Rumipal"
            },
            {
              "code": "X226",
              "description": "Yacanto de Calamuchita"
            }
          ],
          "description": "Córdoba"
        },
        {
          "code": "0007",
          "cities": [
            {
              "code": "CNQ",
              "description": "Corrientes"
            },
            {
              "code": "W227",
              "description": "Corrientes"
            },
            {
              "code": "UZU",
              "description": "Curuzu Cuatia"
            },
            {
              "code": "W228",
              "description": "Empedrado"
            },
            {
              "code": "W229",
              "description": "Esquina"
            },
            {
              "code": "W230",
              "description": "Gobernador Virasoro"
            },
            {
              "code": "OYA",
              "description": "Goya"
            },
            {
              "code": "MCS",
              "description": "Montes Caseros"
            },
            {
              "code": "CNQ",
              "description": "Otra ciudad"
            },
            {
              "code": "W231",
              "description": "Paso De La Patria"
            },
            {
              "code": "AOL",
              "description": "Paso de los Libres"
            },
            {
              "code": "W232",
              "description": "San Roque"
            },
            {
              "code": "W233",
              "description": "Santa Ana de los Guácaras"
            },
            {
              "code": "W234",
              "description": "Santo Tomé"
            },
            {
              "code": "W235",
              "description": "Yapeyú"
            }
          ],
          "description": "Corrientes"
        },
        {
          "code": "0008",
          "cities": [
            {
              "code": "E236",
              "description": "Basavilbaso"
            },
            {
              "code": "E237",
              "description": "Ceibas"
            },
            {
              "code": "E238",
              "description": "Chajari"
            },
            {
              "code": "CO2",
              "description": "Colón"
            },
            {
              "code": "CU6",
              "description": "Concepcion del Uruguay"
            },
            {
              "code": "COC",
              "description": "Concordia"
            },
            {
              "code": "E239",
              "description": "Entre Ríos"
            },
            {
              "code": "FE1",
              "description": "Federación"
            },
            {
              "code": "GHU",
              "description": "Gualeguaychu"
            },
            {
              "code": "PZ1",
              "description": "La Paz"
            },
            {
              "code": "PRA",
              "description": "Otra ciudad"
            },
            {
              "code": "PRA",
              "description": "Paraná"
            },
            {
              "code": "E240",
              "description": "San José"
            },
            {
              "code": "E241",
              "description": "Ubajay"
            },
            {
              "code": "VI5",
              "description": "Victoria"
            },
            {
              "code": "E242",
              "description": "Villa Elisa"
            },
            {
              "code": "E243",
              "description": "Villa Paranacito"
            }
          ],
          "description": "Entre Ríos"
        },
        {
          "code": "0009",
          "cities": [
            {
              "code": "CLX",
              "description": "Clorinda"
            },
            {
              "code": "FMA",
              "description": "Formosa"
            },
            {
              "code": "LLS",
              "description": "Las Lomitas"
            },
            {
              "code": "FMA",
              "description": "Otra ciudad"
            }
          ],
          "description": "Formosa"
        },
        {
          "code": "0010",
          "cities": [
            {
              "code": "Y244",
              "description": "Barrio Los Noveiro (Reyes)"
            },
            {
              "code": "Y245",
              "description": "Calilegua"
            },
            {
              "code": "Y246",
              "description": "Ciudad Perico"
            },
            {
              "code": "Y247",
              "description": "El Carmen"
            },
            {
              "code": "Y248",
              "description": "Huacalera"
            },
            {
              "code": "HU3",
              "description": "Humahuaca"
            },
            {
              "code": "LQ1",
              "description": "La Quiaca"
            },
            {
              "code": "Y249",
              "description": "Libertador General San Martín"
            },
            {
              "code": "Y250",
              "description": "Maimará"
            },
            {
              "code": "JUJ",
              "description": "Otra ciudad"
            },
            {
              "code": "Y251",
              "description": "Palma Sola"
            },
            {
              "code": "Y252",
              "description": "Palpalá"
            },
            {
              "code": "PM2",
              "description": "Purmamarca"
            },
            {
              "code": "Y253",
              "description": "San Pedro de Jujuy"
            },
            {
              "code": "JUJ",
              "description": "San Salvador de Jujuy"
            },
            {
              "code": "Y254",
              "description": "Santa Catalina"
            },
            {
              "code": "Y255",
              "description": "Termas de Reyes"
            },
            {
              "code": "TJL",
              "description": "Tilcara"
            },
            {
              "code": "Y256",
              "description": "Yala"
            }
          ],
          "description": "Jujuy"
        },
        {
          "code": "0011",
          "cities": [
            {
              "code": "L257",
              "description": "Bernardo Larroudé"
            },
            {
              "code": "GPO",
              "description": "General Pico"
            },
            {
              "code": "L258",
              "description": "La Adela"
            },
            {
              "code": "L259",
              "description": "Macachín"
            },
            {
              "code": "RSA",
              "description": "Otra ciudad"
            },
            {
              "code": "L260",
              "description": "Rancul"
            },
            {
              "code": "RSA",
              "description": "Santa Rosa"
            },
            {
              "code": "L261",
              "description": "Sarah"
            },
            {
              "code": "L262",
              "description": "Utracán"
            }
          ],
          "description": "La Pampa"
        },
        {
          "code": "0012",
          "cities": [
            {
              "code": "F263",
              "description": "Aimogasta"
            },
            {
              "code": "F264",
              "description": "Chilecito"
            },
            {
              "code": "F265",
              "description": "Famatina"
            },
            {
              "code": "IRJ",
              "description": "La Rioja"
            },
            {
              "code": "F266",
              "description": "Nonogasta"
            },
            {
              "code": "IRJ",
              "description": "Otra ciudad"
            },
            {
              "code": "F267",
              "description": "Villa Unión"
            }
          ],
          "description": "La Rioja"
        },
        {
          "code": "0013",
          "cities": [
            {
              "code": "M268",
              "description": "Chacras de Coria"
            },
            {
              "code": "M269",
              "description": "El Challao"
            },
            {
              "code": "M270",
              "description": "El Nihuil"
            },
            {
              "code": "M271",
              "description": "Eugenio Bustos"
            },
            {
              "code": "M272",
              "description": "General Alvear"
            },
            {
              "code": "M273",
              "description": "Godoy Cruz"
            },
            {
              "code": "M274",
              "description": "Las Compuertas"
            },
            {
              "code": "M275",
              "description": "Las Heras, Mendoza"
            },
            {
              "code": "LGS",
              "description": "Las Leñas"
            },
            {
              "code": "M276",
              "description": "Los Molles"
            },
            {
              "code": "LP1",
              "description": "Los Penitentes"
            },
            {
              "code": "M277",
              "description": "Lujan de Cuyo"
            },
            {
              "code": "M278",
              "description": "Maipú"
            },
            {
              "code": "M279",
              "description": "Malargüe"
            },
            {
              "code": "MDZ",
              "description": "Mendoza"
            },
            {
              "code": "MDZ",
              "description": "Otra ciudad"
            },
            {
              "code": "M280",
              "description": "Potrerillos"
            },
            {
              "code": "M281",
              "description": "Puente del Inca"
            },
            {
              "code": "M282",
              "description": "Rama Caída"
            },
            {
              "code": "M283",
              "description": "San Martín (Mendoza)"
            },
            {
              "code": "AFA",
              "description": "San Rafael"
            },
            {
              "code": "M284",
              "description": "Tunuyan"
            },
            {
              "code": "M285",
              "description": "Tupungato"
            },
            {
              "code": "M286",
              "description": "Uspallata"
            },
            {
              "code": "M287",
              "description": "Villa Las Cuevas"
            }
          ],
          "description": "Mendoza"
        },
        {
          "code": "0014",
          "cities": [
            {
              "code": "N288",
              "description": "Andresito"
            },
            {
              "code": "N289",
              "description": "Apóstoles"
            },
            {
              "code": "N290",
              "description": "Capioví"
            },
            {
              "code": "N291",
              "description": "Dos de Mayo"
            },
            {
              "code": "N292",
              "description": "El Soberbio"
            },
            {
              "code": "ELO",
              "description": "Eldorado"
            },
            {
              "code": "N293",
              "description": "Garupá"
            },
            {
              "code": "IGU",
              "description": "Iguazu"
            },
            {
              "code": "N294",
              "description": "Jardín América"
            },
            {
              "code": "N295",
              "description": "Leandro N. Alem"
            },
            {
              "code": "N296",
              "description": "Misiónes"
            },
            {
              "code": "N297",
              "description": "Moconá"
            },
            {
              "code": "N298",
              "description": "Montecarlo"
            },
            {
              "code": "OB1",
              "description": "Obera"
            },
            {
              "code": "PSS",
              "description": "Otra ciudad"
            },
            {
              "code": "PSS",
              "description": "Posadas"
            },
            {
              "code": "IGR",
              "description": "Puerto Iguazú"
            },
            {
              "code": "N299",
              "description": "Puerto Libertad"
            },
            {
              "code": "N300",
              "description": "Puerto Mineral"
            },
            {
              "code": "N301",
              "description": "Puerto Rico"
            },
            {
              "code": "SI6",
              "description": "San Ignacio"
            },
            {
              "code": "N302",
              "description": "Wanda"
            }
          ],
          "description": "Misiones"
        },
        {
          "code": "0015",
          "cities": [
            {
              "code": "AL6",
              "description": "Alumine"
            },
            {
              "code": "Q303",
              "description": "Andacollo"
            },
            {
              "code": "Q304",
              "description": "Añelo"
            },
            {
              "code": "CVH",
              "description": "Caviahue"
            },
            {
              "code": "Q305",
              "description": "Centenario"
            },
            {
              "code": "Q306",
              "description": "Cerro Chapelco"
            },
            {
              "code": "Q307",
              "description": "Chos Malal"
            },
            {
              "code": "CP2",
              "description": "Copahue"
            },
            {
              "code": "CUT",
              "description": "Cutral-Co"
            },
            {
              "code": "LA0",
              "description": "Junin de los Andes"
            },
            {
              "code": "MO5",
              "description": "Moquehue"
            },
            {
              "code": "NQ1",
              "description": "Neuquen"
            },
            {
              "code": "NQN",
              "description": "Neuquén"
            },
            {
              "code": "NQN",
              "description": "Otra ciudad"
            },
            {
              "code": "Q308",
              "description": "Plaza Huincul"
            },
            {
              "code": "Q309",
              "description": "Plottier"
            },
            {
              "code": "Q310",
              "description": "Quillén"
            },
            {
              "code": "Q311",
              "description": "Rincón de los Sauces"
            },
            {
              "code": "CPC",
              "description": "San Martín de los Andes"
            },
            {
              "code": "Q312",
              "description": "San Patricio del Chanar"
            },
            {
              "code": "VC3",
              "description": "Villa el Chocon"
            },
            {
              "code": "AN2",
              "description": "Villa La Angostura"
            },
            {
              "code": "Q313",
              "description": "Villa Meliquina"
            },
            {
              "code": "VP1",
              "description": "Villa Pehuenia"
            },
            {
              "code": "VT3",
              "description": "Villa Traful"
            },
            {
              "code": "APZ",
              "description": "Zapala"
            }
          ],
          "description": "Neuquén"
        },
        {
          "code": "0016",
          "cities": [
            {
              "code": "R314",
              "description": "Allen"
            },
            {
              "code": "BCH",
              "description": "Bariloche"
            },
            {
              "code": "CI1",
              "description": "Cipoletti"
            },
            {
              "code": "CCT",
              "description": "Colonia Catriel"
            },
            {
              "code": "R315",
              "description": "Dina Huapi"
            },
            {
              "code": "EHL",
              "description": "El Bolson"
            },
            {
              "code": "GNR",
              "description": "General Roca"
            },
            {
              "code": "IGB",
              "description": "Ingeniero Jacobacci"
            },
            {
              "code": "GR2",
              "description": "Las Grutas"
            },
            {
              "code": "LMD",
              "description": "Los Menucos"
            },
            {
              "code": "MQD",
              "description": "Maquinchao"
            },
            {
              "code": "VDM",
              "description": "Otra ciudad"
            },
            {
              "code": "R316",
              "description": "Río Colorado"
            },
            {
              "code": "R317",
              "description": "Río Negro"
            },
            {
              "code": "R318",
              "description": "Río Villegas"
            },
            {
              "code": "SE5",
              "description": "San Antonio Este"
            },
            {
              "code": "OES",
              "description": "San Antonio Oeste"
            },
            {
              "code": "BRC",
              "description": "San Carlos de Bariloche"
            },
            {
              "code": "SGV",
              "description": "Sierra Grande"
            },
            {
              "code": "VCF",
              "description": "Valcheta"
            },
            {
              "code": "VDM",
              "description": "Viedma"
            },
            {
              "code": "R319",
              "description": "Villa Catedral"
            },
            {
              "code": "VR1",
              "description": "Villa Regina"
            }
          ],
          "description": "Río Negro"
        },
        {
          "code": "0017",
          "cities": [
            {
              "code": "A320",
              "description": "Angastaco"
            },
            {
              "code": "CC1",
              "description": "Cabra Corral"
            },
            {
              "code": "A321",
              "description": "Cachi"
            },
            {
              "code": "CF2",
              "description": "Cafayate"
            },
            {
              "code": "A322",
              "description": "Campo Quijano"
            },
            {
              "code": "A323",
              "description": "Chicoana"
            },
            {
              "code": "CM0",
              "description": "Coronel Moldes"
            },
            {
              "code": "A324",
              "description": "El Bordo"
            },
            {
              "code": "A325",
              "description": "General Güemes"
            },
            {
              "code": "A326",
              "description": "Iruya"
            },
            {
              "code": "A327",
              "description": "La Caldera"
            },
            {
              "code": "A328",
              "description": "La Merced"
            },
            {
              "code": "A329",
              "description": "La Silleta"
            },
            {
              "code": "A330",
              "description": "Molinos"
            },
            {
              "code": "ORA",
              "description": "Oran"
            },
            {
              "code": "SLA",
              "description": "Otra ciudad"
            },
            {
              "code": "A331",
              "description": "Rosario de la Frontera"
            },
            {
              "code": "A332",
              "description": "Rosario de Lerma"
            },
            {
              "code": "SLA",
              "description": "Salta"
            },
            {
              "code": "A333",
              "description": "San Antonio de los Cobres"
            },
            {
              "code": "TTG",
              "description": "Tartagal"
            },
            {
              "code": "A334",
              "description": "Vaqueros"
            },
            {
              "code": "SL0",
              "description": "Villa San Lorenzo"
            }
          ],
          "description": "Salta"
        },
        {
          "code": "0018",
          "cities": [
            {
              "code": "J335",
              "description": "Barreal"
            },
            {
              "code": "UAQ",
              "description": "Otra ciudad"
            },
            {
              "code": "J336",
              "description": "Rodeo"
            },
            {
              "code": "J337",
              "description": "San Agustín de Valle Fértil"
            },
            {
              "code": "J338",
              "description": "San José de Jáchal"
            },
            {
              "code": "UAQ",
              "description": "San Juan"
            },
            {
              "code": "VL2",
              "description": "Valle de la Luna"
            },
            {
              "code": "J339",
              "description": "Villa San Agustin"
            }
          ],
          "description": "San Juan"
        },
        {
          "code": "0019",
          "cities": [
            {
              "code": "D340",
              "description": "Carpintería"
            },
            {
              "code": "D341",
              "description": "Cortaderas"
            },
            {
              "code": "D342",
              "description": "El Volcán"
            },
            {
              "code": "D343",
              "description": "Lago Potrero de los Funes"
            },
            {
              "code": "D344",
              "description": "Nogolí"
            },
            {
              "code": "LUQ",
              "description": "Otra ciudad"
            },
            {
              "code": "D345",
              "description": "Papagayos"
            },
            {
              "code": "PF0",
              "description": "Potrero de los Funes"
            },
            {
              "code": "D346",
              "description": "San Javier y Yacanto"
            },
            {
              "code": "LUQ",
              "description": "San Luis"
            },
            {
              "code": "D347",
              "description": "Santa Rosa de Conlara"
            },
            {
              "code": "D348",
              "description": "Trapiche"
            },
            {
              "code": "D349",
              "description": "Villa Elena"
            },
            {
              "code": "VME",
              "description": "Villa Mercedes"
            }
          ],
          "description": "San Luis"
        },
        {
          "code": "0020",
          "cities": [
            {
              "code": "CFE",
              "description": "Calafate"
            },
            {
              "code": "CVI",
              "description": "Caleta Olivia"
            },
            {
              "code": "FTE",
              "description": "El Calafate"
            },
            {
              "code": "CH2",
              "description": "El Chaltén"
            },
            {
              "code": "GGS",
              "description": "Gobernador dos Gregores"
            },
            {
              "code": "LHS",
              "description": "Las Heras"
            },
            {
              "code": "LO3",
              "description": "Los Antiguos"
            },
            {
              "code": "RGL",
              "description": "Otra ciudad"
            },
            {
              "code": "Z350",
              "description": "Pcia de Santa Cruz"
            },
            {
              "code": "PMQ",
              "description": "Perito Moreno"
            },
            {
              "code": "PUD",
              "description": "Puerto Deseado"
            },
            {
              "code": "PJ1",
              "description": "Puerto San Julian"
            },
            {
              "code": "RYO",
              "description": "Rio Turbio"
            },
            {
              "code": "RGL",
              "description": "Río Gallegos"
            },
            {
              "code": "ULA",
              "description": "San Julian"
            },
            {
              "code": "RZA",
              "description": "Santa Cruz"
            }
          ],
          "description": "Santa Cruz"
        },
        {
          "code": "0021",
          "cities": [
            {
              "code": "S351",
              "description": "Armstrong"
            },
            {
              "code": "S352",
              "description": "Arroyo Seco"
            },
            {
              "code": "S353",
              "description": "Calchaquí"
            },
            {
              "code": "S354",
              "description": "Cayasta"
            },
            {
              "code": "CRR",
              "description": "Ceres"
            },
            {
              "code": "S355",
              "description": "Colonia Carlos Pellegrini"
            },
            {
              "code": "S356",
              "description": "Desvio Arijón"
            },
            {
              "code": "S357",
              "description": "Funes"
            },
            {
              "code": "S358",
              "description": "Ibarlucea"
            },
            {
              "code": "S359",
              "description": "Las Rosas"
            },
            {
              "code": "S360",
              "description": "Oliveros"
            },
            {
              "code": "SFN",
              "description": "Otra ciudad"
            },
            {
              "code": "S361",
              "description": "Rafaela"
            },
            {
              "code": "RCQ",
              "description": "Reconquista"
            },
            {
              "code": "S362",
              "description": "Romang"
            },
            {
              "code": "ROS",
              "description": "Rosario"
            },
            {
              "code": "S363",
              "description": "San Javier"
            },
            {
              "code": "OLR",
              "description": "San Lorenzo"
            },
            {
              "code": "SFN",
              "description": "Santa Fe"
            },
            {
              "code": "S364",
              "description": "Sauce Viejo"
            },
            {
              "code": "S365",
              "description": "Venado Tuerto"
            },
            {
              "code": "S366",
              "description": "Vera"
            },
            {
              "code": "S367",
              "description": "Zavalla"
            }
          ],
          "description": "Santa Fe"
        },
        {
          "code": "0022",
          "cities": [
            {
              "code": "G368",
              "description": "El Hoyo"
            },
            {
              "code": "G369",
              "description": "Frías"
            },
            {
              "code": "G370",
              "description": "Loreto"
            },
            {
              "code": "SDE",
              "description": "Otra ciudad"
            },
            {
              "code": "RH1",
              "description": "Rio Hondo"
            },
            {
              "code": "RHD",
              "description": "Rio Hondo"
            },
            {
              "code": "SDE",
              "description": "Santiago del Estero"
            },
            {
              "code": "G371",
              "description": "Termas de Rio Hondo"
            }
          ],
          "description": "Santiago del Estero"
        },
        {
          "code": "0023",
          "cities": [
            {
              "code": "USH",
              "description": "Otra ciudad"
            },
            {
              "code": "RGA",
              "description": "Rio Grande"
            },
            {
              "code": "V372",
              "description": "Tolhuin"
            },
            {
              "code": "USH",
              "description": "Ushuaia"
            }
          ],
          "description": "Tierra del Fuego"
        },
        {
          "code": "0024",
          "cities": [
            {
              "code": "T373",
              "description": "Calimonte"
            },
            {
              "code": "T374",
              "description": "Concepcion"
            },
            {
              "code": "T375",
              "description": "El Mollar"
            },
            {
              "code": "TUC",
              "description": "Otra ciudad"
            },
            {
              "code": "TUC",
              "description": "San Miguel de Tucumán"
            },
            {
              "code": "T376",
              "description": "San Pedro de Colalao"
            },
            {
              "code": "TA1",
              "description": "Tafí del Valle"
            },
            {
              "code": "T377",
              "description": "Yerba Buena"
            }
          ],
          "description": "Tucumán"
        }
      ];

      return response;
}

export const getProvinceUY = () =>{
  const response = [
    {
      "code": "MON",
      "cities": [
        {
          "code": "032",
          "description": "Montevideo"
        }
      ],
      "description": "Montevideo"
    },
    {
      "code": "ART",
      "cities": [
        {
          "code": "006",
          "description": "Artigas"
        },
        {
          "code": "007",
          "description": "Baltasar Brum"
        },
        {
          "code": "021",
          "description": "Bella Union"
        }
      ],
      "description": "Artigas"
    },
    {
      "code": "CAN",
      "cities": [
        {
          "code": "004",
          "description": "Canelones"
        },
        {
          "code": "013",
          "description": "Santa Lucia"
        }
      ],
      "description": "Canelones"
    },
    {
      "code": "CER",
      "cities": [
        {
          "code": "023",
          "description": "Melo"
        }
      ],
      "description": "Cerro Largo"
    },
    {
      "code": "COL",
      "cities": [
        {
          "code": "001",
          "description": "Colonia del Sacramento"
        },
        {
          "code": "020",
          "description": "Carmelo"
        }
      ],
      "description": "Colonia"
    },
    {
      "code": "DUR",
      "cities": [
        {
          "code": "031",
          "description": "Durazno"
        }
      ],
      "description": "Durazno"
    },
    {
      "code": "FLO",
      "cities": [
        {
          "code": "002",
          "description": "Trinidad"
        }
      ],
      "description": "Flores"
    },
    {
      "code": "FLO",
      "cities": [
        {
          "code": "005",
          "description": "Florida"
        }
      ],
      "description": "Florida"
    },
    {
      "code": "LAV",
      "cities": [
        {
          "code": "014",
          "description": "Jose Batlle y Ordonez"
        },
        {
          "code": "015",
          "description": "Minas"
        }
      ],
      "description": "Lavalleja"
    },
    {
      "code": "MAL",
      "cities": [
        {
          "code": "016",
          "description": "Maldonado"
        },
        {
          "code": "017",
          "description": "Punta del Este"
        },
        {
          "code": "018",
          "description": "Aigua"
        }
      ],
      "description": "Maldonado"
    },
    {
      "code": "PAY",
      "cities": [
        {
          "code": "029",
          "description": "Paysandu"
        }
      ],
      "description": "Paysandú"
    },
    {
      "code": "RIV",
      "cities": [
        {
          "code": "008",
          "description": "Tranqueras"
        },
        {
          "code": "024",
          "description": "Rivera"
        }
      ],
      "description": "Rivera"
    },
    {
      "code": "ROC",
      "cities": [
        {
          "code": "019",
          "description": "La Paloma"
        },
        {
          "code": "025",
          "description": "Lascano"
        },
        {
          "code": "026",
          "description": "Castillos"
        },
        {
          "code": "028",
          "description": "Rocha"
        }
      ],
      "description": "Rocha"
    },
    {
      "code": "RÍO",
      "cities": [
        {
          "code": "003",
          "description": "Fray Bentos"
        }
      ],
      "description": "Río Negro"
    },
    {
      "code": "SAL",
      "cities": [
        {
          "code": "030",
          "description": "Salto"
        }
      ],
      "description": "Salto"
    },
    {
      "code": "SAN",
      "cities": [
        {
          "code": "027",
          "description": "San Jose de Mayo"
        }
      ],
      "description": "San José"
    },
    {
      "code": "SOR",
      "cities": [
        {
          "code": "022",
          "description": "Mercedes"
        }
      ],
      "description": "Soriano"
    },
    {
      "code": "TAC",
      "cities": [
        {
          "code": "009",
          "description": "Tacuarembo"
        },
        {
          "code": "010",
          "description": "Paso de los Toros"
        }
      ],
      "description": "Tacuarembó"
    },
    {
      "code": "TRE",
      "cities": [
        {
          "code": "011",
          "description": "Vergara"
        },
        {
          "code": "012",
          "description": "Treinta y Tres"
        }
      ],
      "description": "Treinta y Tres"
    }
  ];

  return response;
}

export const getDocType = () =>{
    const response = [
        {"code": "Dni","description": "DNI"},
        {"code": "Lc","description": "LC"},
        {"code": "PP","description": "PAS"}
    ];

    return response;
}

export const getDocTypePayment = () =>{
  const response = [
      {"code": "Dni","description": "DNI"},
      {"code": "Lc","description": "LC"}
  ];

  return response;
}

export const getNumberType = () =>{
    const response = [
        {"code": "CUIL","description": "CUIL"},
        {"code": "CDI","description": "CDI"}
    ];

    return response;
}

export const getSituation = () =>{
    const response = [
        {"code": "04","description": "Consumidor Final"},
        {"code": "01","description": "Responsable Inscripto"},
        {"code": "03","description": "Exento"},
        {"code": "05","description": "Monotributo"},
        {"code": "06","description": "No Responsables"}
    ];

    return response;
}

export const getGenre = () =>{
    const response = [
        {"code": "M","description": "M"},
        {"code": "F","description": "F"}
    ];

    return response;
}

export const getCountry = () => {
    const response = [
          {
            "id": 1,
            "code": "AFG",
            "code_2": "AF",
            "description": "Afghanistan"
          },
          {
            "id": 2,
            "code": "ALB",
            "code_2": "AL",
            "description": "Albania"
          },
          {
            "id": 3,
            "code": "DZA",
            "code_2": "DZ",
            "description": "Algeria"
          },
          {
            "id": 4,
            "code": "ASM",
            "code_2": "AS",
            "description": "American Samoa"
          },
          {
            "id": 5,
            "code": "AND",
            "code_2": "AD",
            "description": "Andorra"
          },
          {
            "id": 6,
            "code": "AGO",
            "code_2": "AO",
            "description": "Angola"
          },
          {
            "id": 7,
            "code": "AIA",
            "code_2": "AI",
            "description": "Anguilla"
          },
          {
            "id": 8,
            "code": "ATA",
            "code_2": "AQ",
            "description": "Antarctica"
          },
          {
            "id": 9,
            "code": "ATG",
            "code_2": "AG",
            "description": "Antigua and Barbuda"
          },
          {
            "id": 10,
            "code": "ARG",
            "code_2": "AR",
            "description": "Argentina"
          },
          {
            "id": 11,
            "code": "ARM",
            "code_2": "AM",
            "description": "Armenia"
          },
          {
            "id": 12,
            "code": "ABW",
            "code_2": "AW",
            "description": "Aruba"
          },
          {
            "id": 13,
            "code": "AUS",
            "code_2": "AU",
            "description": "Australia"
          },
          {
            "id": 14,
            "code": "AUT",
            "code_2": "AT",
            "description": "Austria"
          },
          {
            "id": 15,
            "code": "AZE",
            "code_2": "AZ",
            "description": "Azerbaijan"
          },
          {
            "id": 16,
            "code": "BHS",
            "code_2": "BS",
            "description": "Bahamas"
          },
          {
            "id": 17,
            "code": "BHR",
            "code_2": "BH",
            "description": "Bahrain"
          },
          {
            "id": 18,
            "code": "BGD",
            "code_2": "BD",
            "description": "Bangladesh"
          },
          {
            "id": 19,
            "code": "BRB",
            "code_2": "BB",
            "description": "Barbados"
          },
          {
            "id": 20,
            "code": "BLR",
            "code_2": "BY",
            "description": "Belarus"
          },
          {
            "id": 21,
            "code": "BEL",
            "code_2": "BE",
            "description": "Belgium"
          },
          {
            "id": 22,
            "code": "BLZ",
            "code_2": "BZ",
            "description": "Belize"
          },
          {
            "id": 23,
            "code": "BEN",
            "code_2": "BJ",
            "description": "Benin"
          },
          {
            "id": 24,
            "code": "BMU",
            "code_2": "BM",
            "description": "Bermuda"
          },
          {
            "id": 25,
            "code": "BTN",
            "code_2": "BT",
            "description": "Bhutan"
          },
          {
            "id": 26,
            "code": "BOL",
            "code_2": "BO",
            "description": "Bolivia"
          },
          {
            "id": 27,
            "code": "BIH",
            "code_2": "BA",
            "description": "Bosnia and Herzegovina"
          },
          {
            "id": 28,
            "code": "BWA",
            "code_2": "BW",
            "description": "Botswana"
          },
          {
            "id": 29,
            "code": "BVT",
            "code_2": "BV",
            "description": "Bouvet Island"
          },
          {
            "id": 30,
            "code": "BRA",
            "code_2": "BR",
            "description": "Brazil"
          },
          {
            "id": 31,
            "code": "IOT",
            "code_2": "IO",
            "description": "British Indian Ocean Territory"
          },
          {
            "id": 32,
            "code": "VGB",
            "code_2": "VG",
            "description": "British Virgin Islands"
          },
          {
            "id": 33,
            "code": "BRN",
            "code_2": "BN",
            "description": "Brunei Darussalam"
          },
          {
            "id": 34,
            "code": "BGR",
            "code_2": "BG",
            "description": "Bulgaria"
          },
          {
            "id": 35,
            "code": "BFA",
            "code_2": "BF",
            "description": "Burkina Faso"
          },
          {
            "id": 36,
            "code": "MMR",
            "code_2": "MM",
            "description": "Burma"
          },
          {
            "id": 37,
            "code": "BDI",
            "code_2": "BI",
            "description": "Burundi"
          },
          {
            "id": 38,
            "code": "KHM",
            "code_2": "KH",
            "description": "Cambodia"
          },
          {
            "id": 39,
            "code": "CMR",
            "code_2": "CM",
            "description": "Cameroon"
          },
          {
            "id": 40,
            "code": "CAN",
            "code_2": "CA",
            "description": "Canada"
          },
          {
            "id": 41,
            "code": "CPV",
            "code_2": "CV",
            "description": "Cape Verde"
          },
          {
            "id": 42,
            "code": "CYM",
            "code_2": "KY",
            "description": "Cayman Islands"
          },
          {
            "id": 43,
            "code": "CAF",
            "code_2": "CF",
            "description": "Central African Republic"
          },
          {
            "id": 44,
            "code": "TCD",
            "code_2": "TD",
            "description": "Chad"
          },
          {
            "id": 45,
            "code": "CHL",
            "code_2": "CL",
            "description": "Chile"
          },
          {
            "id": 46,
            "code": "CHN",
            "code_2": "CN",
            "description": "China"
          },
          {
            "id": 47,
            "code": "CXR",
            "code_2": "CX",
            "description": "Christmas Island"
          },
          {
            "id": 48,
            "code": "CCK",
            "code_2": "CC",
            "description": "Cocos (Keeling) Islands"
          },
          {
            "id": 49,
            "code": "COL",
            "code_2": "CO",
            "description": "Colombia"
          },
          {
            "id": 50,
            "code": "COM",
            "code_2": "KM",
            "description": "Comoros"
          },
          {
            "id": 51,
            "code": "COG",
            "code_2": "CG",
            "description": "Congo, Republic of the"
          },
          {
            "id": 52,
            "code": "COK",
            "code_2": "CK",
            "description": "Cook Islands"
          },
          {
            "id": 53,
            "code": "CRI",
            "code_2": "CR",
            "description": "Costa Rica"
          },
          {
            "id": 54,
            "code": "CIV",
            "code_2": "CI",
            "description": "Cote d'Ivoire"
          },
          {
            "id": 55,
            "code": "HRV",
            "code_2": "HR",
            "description": "Croatia"
          },
          {
            "id": 56,
            "code": "CUB",
            "code_2": "CU",
            "description": "Cuba"
          },
          {
            "id": 57,
            "code": "CYP",
            "code_2": "CY",
            "description": "Cyprus"
          },
          {
            "id": 58,
            "code": "CZE",
            "code_2": "CZ",
            "description": "Czech Republic"
          },
          {
            "id": 59,
            "code": "COD",
            "code_2": "CD",
            "description": "Democratic Republic of the Congo (DRC)"
          },
          {
            "id": 60,
            "code": "DNK",
            "code_2": "DK",
            "description": "Denmark"
          },
          {
            "id": 61,
            "code": "DJI",
            "code_2": "DJ",
            "description": "Djibouti"
          },
          {
            "id": 62,
            "code": "DMA",
            "code_2": "DM",
            "description": "Dominica"
          },
          {
            "id": 63,
            "code": "DOM",
            "code_2": "DO",
            "description": "Dominican Republic"
          },
          {
            "id": 64,
            "code": "TLS",
            "code_2": "TL",
            "description": "East Timor"
          },
          {
            "id": 65,
            "code": "ECU",
            "code_2": "EC",
            "description": "Ecuador"
          },
          {
            "id": 66,
            "code": "EGY",
            "code_2": "EG",
            "description": "Egypt"
          },
          {
            "id": 67,
            "code": "SLV",
            "code_2": "SV",
            "description": "El Salvador"
          },
          {
            "id": 68,
            "code": "GNQ",
            "code_2": "GQ",
            "description": "Equatorial Guinea"
          },
          {
            "id": 69,
            "code": "ERI",
            "code_2": "ER",
            "description": "Eritrea"
          },
          {
            "id": 70,
            "code": "EST",
            "code_2": "EE",
            "description": "Estonia"
          },
          {
            "id": 71,
            "code": "ETH",
            "code_2": "ET",
            "description": "Ethiopia"
          },
          {
            "id": 72,
            "code": "FLK",
            "code_2": "FK",
            "description": "Falkland Islands (Islas Malvinas)"
          },
          {
            "id": 73,
            "code": "FRO",
            "code_2": "FO",
            "description": "Faroe Islands"
          },
          {
            "id": 74,
            "code": "FJI",
            "code_2": "FJ",
            "description": "Fiji"
          },
          {
            "id": 75,
            "code": "FIN",
            "code_2": "FI",
            "description": "Finland"
          },
          {
            "id": 76,
            "code": "FRA",
            "code_2": "FR",
            "description": "France"
          },
          {
            "id": 77,
            "code": "GUF",
            "code_2": "GF",
            "description": "French Guiana"
          },
          {
            "id": 78,
            "code": "PYF",
            "code_2": "PF",
            "description": "French Polynesia"
          },
          {
            "id": 79,
            "code": "ATF",
            "code_2": "TF",
            "description": "French Southern and Antarctic Lands"
          },
          {
            "id": 80,
            "code": "GAB",
            "code_2": "GA",
            "description": "Gabon"
          },
          {
            "id": 81,
            "code": "GEO",
            "code_2": "GE",
            "description": "Georgia"
          },
          {
            "id": 82,
            "code": "DEU",
            "code_2": "DE",
            "description": "Germany"
          },
          {
            "id": 83,
            "code": "GHA",
            "code_2": "GH",
            "description": "Ghana"
          },
          {
            "id": 84,
            "code": "GIB",
            "code_2": "GI",
            "description": "Gibraltar"
          },
          {
            "id": 85,
            "code": "GRC",
            "code_2": "GR",
            "description": "Greece"
          },
          {
            "id": 86,
            "code": "GRL",
            "code_2": "GL",
            "description": "Greenland"
          },
          {
            "id": 87,
            "code": "GRD",
            "code_2": "GD",
            "description": "Grenada"
          },
          {
            "id": 88,
            "code": "GLP",
            "code_2": "GP",
            "description": "Guadeloupe"
          },
          {
            "id": 89,
            "code": "GUM",
            "code_2": "GU",
            "description": "Guam"
          },
          {
            "id": 90,
            "code": "GTM",
            "code_2": "GT",
            "description": "Guatemala"
          },
          {
            "id": 91,
            "code": "GIN",
            "code_2": "GN",
            "description": "Guinea"
          },
          {
            "id": 92,
            "code": "GNB",
            "code_2": "GW",
            "description": "Guinea-Bissau"
          },
          {
            "id": 93,
            "code": "GUY",
            "code_2": "GY",
            "description": "Guyana"
          },
          {
            "id": 94,
            "code": "HTI",
            "code_2": "HT",
            "description": "Haiti"
          },
          {
            "id": 95,
            "code": "HMD",
            "code_2": "HM",
            "description": "Heard Island and McDonald Islands"
          },
          {
            "id": 96,
            "code": "VAT",
            "code_2": "VA",
            "description": "Holy See (Vatican City)"
          },
          {
            "id": 97,
            "code": "HND",
            "code_2": "HN",
            "description": "Honduras"
          },
          {
            "id": 98,
            "code": "HKG",
            "code_2": "HK",
            "description": "Hong Kong (SAR)"
          },
          {
            "id": 99,
            "code": "HUN",
            "code_2": "HU",
            "description": "Hungary"
          },
          {
            "id": 100,
            "code": "ISL",
            "code_2": "IS",
            "description": "Iceland"
          },
          {
            "id": 101,
            "code": "IND",
            "code_2": "IN",
            "description": "India"
          },
          {
            "id": 102,
            "code": "IDN",
            "code_2": "ID",
            "description": "Indonesia"
          },
          {
            "id": 103,
            "code": "IRN",
            "code_2": "IR",
            "description": "Iran"
          },
          {
            "id": 104,
            "code": "IRQ",
            "code_2": "IQ",
            "description": "Iraq"
          },
          {
            "id": 105,
            "code": "IRL",
            "code_2": "IE",
            "description": "Ireland"
          },
          {
            "id": 106,
            "code": "ISR",
            "code_2": "IL",
            "description": "Israel"
          },
          {
            "id": 107,
            "code": "ITA",
            "code_2": "IT",
            "description": "Italy"
          },
          {
            "id": 108,
            "code": "JAM",
            "code_2": "JM",
            "description": "Jamaica"
          },
          {
            "id": 109,
            "code": "JPN",
            "code_2": "JP",
            "description": "Japan"
          },
          {
            "id": 110,
            "code": "JOR",
            "code_2": "JO",
            "description": "Jordan"
          },
          {
            "id": 111,
            "code": "KAZ",
            "code_2": "KZ",
            "description": "Kazakhstan"
          },
          {
            "id": 112,
            "code": "KEN",
            "code_2": "KE",
            "description": "Kenya"
          },
          {
            "id": 113,
            "code": "KIR",
            "code_2": "KI",
            "description": "Kiribati"
          },
          {
            "id": 114,
            "code": "PRK",
            "code_2": "KP",
            "description": "Korea, North"
          },
          {
            "id": 115,
            "code": "KOR",
            "code_2": "KR",
            "description": "Korea, South"
          },
          {
            "id": 116,
            "code": "KWT",
            "code_2": "KW",
            "description": "Kuwait"
          },
          {
            "id": 117,
            "code": "KGZ",
            "code_2": "KG",
            "description": "Kyrgyzstan"
          },
          {
            "id": 118,
            "code": "LAO",
            "code_2": "LA",
            "description": "Laos"
          },
          {
            "id": 119,
            "code": "LVA",
            "code_2": "LV",
            "description": "Latvia"
          },
          {
            "id": 120,
            "code": "LBN",
            "code_2": "LB",
            "description": "Lebanon"
          },
          {
            "id": 121,
            "code": "LSO",
            "code_2": "LS",
            "description": "Lesotho"
          },
          {
            "id": 122,
            "code": "LBR",
            "code_2": "LR",
            "description": "Liberia"
          },
          {
            "id": 123,
            "code": "LBY",
            "code_2": "LY",
            "description": "Libya"
          },
          {
            "id": 124,
            "code": "LIE",
            "code_2": "LI",
            "description": "Liechtenstein"
          },
          {
            "id": 125,
            "code": "LTU",
            "code_2": "LT",
            "description": "Lithuania"
          },
          {
            "id": 126,
            "code": "LUX",
            "code_2": "LU",
            "description": "Luxembourg"
          },
          {
            "id": 127,
            "code": "MAC",
            "code_2": "MO",
            "description": "Macao"
          },
          {
            "id": 128,
            "code": "MKD",
            "code_2": "MK",
            "description": "Macedonia, The Former Yugoslav Republic of"
          },
          {
            "id": 129,
            "code": "MDG",
            "code_2": "MG",
            "description": "Madagascar"
          },
          {
            "id": 130,
            "code": "MWI",
            "code_2": "MW",
            "description": "Malawi"
          },
          {
            "id": 131,
            "code": "MYS",
            "code_2": "MY",
            "description": "Malaysia"
          },
          {
            "id": 132,
            "code": "MDV",
            "code_2": "MV",
            "description": "Maldives"
          },
          {
            "id": 133,
            "code": "MLI",
            "code_2": "ML",
            "description": "Mali"
          },
          {
            "id": 134,
            "code": "MLT",
            "code_2": "MT",
            "description": "Malta"
          },
          {
            "id": 135,
            "code": "MHL",
            "code_2": "MH",
            "description": "Marshall Islands"
          },
          {
            "id": 136,
            "code": "MTQ",
            "code_2": "MQ",
            "description": "Martinique"
          },
          {
            "id": 137,
            "code": "MRT",
            "code_2": "MR",
            "description": "Mauritania"
          },
          {
            "id": 138,
            "code": "MUS",
            "code_2": "MU",
            "description": "Mauritius"
          },
          {
            "id": 139,
            "code": "MYT",
            "code_2": "YT",
            "description": "Mayotte"
          },
          {
            "id": 140,
            "code": "MEX",
            "code_2": "MX",
            "description": "Mexico"
          },
          {
            "id": 141,
            "code": "FSM",
            "code_2": "FM",
            "description": "Micronesia, Federated States of"
          },
          {
            "id": 142,
            "code": "MDA",
            "code_2": "MD",
            "description": "Moldova"
          },
          {
            "id": 143,
            "code": "MCO",
            "code_2": "MC",
            "description": "Monaco"
          },
          {
            "id": 144,
            "code": "MNG",
            "code_2": "MN",
            "description": "Mongolia"
          },
          {
            "id": 145,
            "code": "MSR",
            "code_2": "MS",
            "description": "Montserrat"
          },
          {
            "id": 146,
            "code": "MAR",
            "code_2": "MA",
            "description": "Morocco"
          },
          {
            "id": 147,
            "code": "MOZ",
            "code_2": "MZ",
            "description": "Mozambique"
          },
          {
            "id": 148,
            "code": "NAM",
            "code_2": "NA",
            "description": "Namibia"
          },
          {
            "id": 149,
            "code": "NRU",
            "code_2": "NR",
            "description": "Nauru"
          },
          {
            "id": 150,
            "code": "NPL",
            "code_2": "NP",
            "description": "Nepal"
          },
          {
            "id": 151,
            "code": "NLD",
            "code_2": "NL",
            "description": "Netherlands"
          },
          {
            "id": 152,
            "code": "ANT",
            "code_2": "AN",
            "description": "Netherlands Antilles"
          },
          {
            "id": 153,
            "code": "NCL",
            "code_2": "NC",
            "description": "New Caledonia"
          },
          {
            "id": 154,
            "code": "NZL",
            "code_2": "NZ",
            "description": "New Zealand"
          },
          {
            "id": 155,
            "code": "NIC",
            "code_2": "NI",
            "description": "Nicaragua"
          },
          {
            "id": 156,
            "code": "NER",
            "code_2": "NE",
            "description": "Niger"
          },
          {
            "id": 157,
            "code": "NGA",
            "code_2": "NG",
            "description": "Nigeria"
          },
          {
            "id": 158,
            "code": "NIU",
            "code_2": "NU",
            "description": "Niue"
          },
          {
            "id": 159,
            "code": "NFK",
            "code_2": "NF",
            "description": "Norfolk Island"
          },
          {
            "id": 160,
            "code": "MNP",
            "code_2": "MP",
            "description": "Northern Mariana Islands"
          },
          {
            "id": 161,
            "code": "NOR",
            "code_2": "NO",
            "description": "Norway"
          },
          {
            "id": 162,
            "code": "OMN",
            "code_2": "OM",
            "description": "Oman"
          },
          {
            "id": 163,
            "code": null,
            "code_2": "ot",
            "description": "Otro"
          },
          {
            "id": 164,
            "code": "PAK",
            "code_2": "PK",
            "description": "Pakistan"
          },
          {
            "id": 165,
            "code": "PLW",
            "code_2": "PW",
            "description": "Palau"
          },
          {
            "id": 166,
            "code": null,
            "code_2": "PS",
            "description": "Palestinian Territory, Occupied"
          },
          {
            "id": 167,
            "code": "PAN",
            "code_2": "PA",
            "description": "Panama"
          },
          {
            "id": 168,
            "code": "PNG",
            "code_2": "PG",
            "description": "Papua New Guinea"
          },
          {
            "id": 169,
            "code": "PRY",
            "code_2": "PY",
            "description": "Paraguay"
          },
          {
            "id": 170,
            "code": "PER",
            "code_2": "PE",
            "description": "Peru"
          },
          {
            "id": 171,
            "code": "PHL",
            "code_2": "PH",
            "description": "Philippines"
          },
          {
            "id": 172,
            "code": "PCN",
            "code_2": "PN",
            "description": "Pitcairn Islands"
          },
          {
            "id": 173,
            "code": "POL",
            "code_2": "PL",
            "description": "Poland"
          },
          {
            "id": 174,
            "code": "PRT",
            "code_2": "PT",
            "description": "Portugal"
          },
          {
            "id": 175,
            "code": "PRI",
            "code_2": "PR",
            "description": "Puerto Rico"
          },
          {
            "id": 176,
            "code": "QAT",
            "code_2": "QA",
            "description": "Qatar"
          },
          {
            "id": 177,
            "code": "REU",
            "code_2": "RE",
            "description": "R?union"
          },
          {
            "id": 178,
            "code": "ROU",
            "code_2": "RO",
            "description": "Romania"
          },
          {
            "id": 179,
            "code": "RUS",
            "code_2": "RU",
            "description": "Russia"
          },
          {
            "id": 180,
            "code": "RWA",
            "code_2": "RW",
            "description": "Rwanda"
          },
          {
            "id": 181,
            "code": "STP",
            "code_2": "ST",
            "description": "S?o Tom? and Pr?ncipe"
          },
          {
            "id": 182,
            "code": "SHN",
            "code_2": "SH",
            "description": "Saint Helena"
          },
          {
            "id": 183,
            "code": "KNA",
            "code_2": "KN",
            "description": "Saint Kitts and Nevis"
          },
          {
            "id": 184,
            "code": "LCA",
            "code_2": "LC",
            "description": "Saint Lucia"
          },
          {
            "id": 185,
            "code": "SPM",
            "code_2": "PM",
            "description": "Saint Pierre and Miquelon"
          },
          {
            "id": 186,
            "code": "VCT",
            "code_2": "VC",
            "description": "Saint Vincent and the Grenadines"
          },
          {
            "id": 187,
            "code": "WSM",
            "code_2": "WS",
            "description": "Samoa"
          },
          {
            "id": 188,
            "code": "SMR",
            "code_2": "SM",
            "description": "San Marino"
          },
          {
            "id": 189,
            "code": "SAU",
            "code_2": "SA",
            "description": "Saudi Arabia"
          },
          {
            "id": 190,
            "code": "SEN",
            "code_2": "SN",
            "description": "Senegal"
          },
          {
            "id": 191,
            "code": "SYC",
            "code_2": "SC",
            "description": "Seychelles"
          },
          {
            "id": 192,
            "code": "SLE",
            "code_2": "SL",
            "description": "Sierra Leone"
          },
          {
            "id": 193,
            "code": "SGP",
            "code_2": "SG",
            "description": "Singapore"
          },
          {
            "id": 194,
            "code": "SVK",
            "code_2": "SK",
            "description": "Slovakia"
          },
          {
            "id": 195,
            "code": "SVN",
            "code_2": "SI",
            "description": "Slovenia"
          },
          {
            "id": 196,
            "code": "SLB",
            "code_2": "SB",
            "description": "Solomon Islands"
          },
          {
            "id": 197,
            "code": "SOM",
            "code_2": "SO",
            "description": "Somalia"
          },
          {
            "id": 198,
            "code": "ZAF",
            "code_2": "ZA",
            "description": "South Africa"
          },
          {
            "id": 199,
            "code": "SGS",
            "code_2": "GS",
            "description": "South Georgia and the South Sandwich Islands"
          },
          {
            "id": 200,
            "code": "ESP",
            "code_2": "ES",
            "description": "España"
          },
          {
            "id": 201,
            "code": "LKA",
            "code_2": "LK",
            "description": "Sri Lanka"
          },
          {
            "id": 202,
            "code": "SDN",
            "code_2": "SD",
            "description": "Sudan"
          },
          {
            "id": 203,
            "code": "SUR",
            "code_2": "SR",
            "description": "Suriname"
          },
          {
            "id": 204,
            "code": "SJM",
            "code_2": "SJ",
            "description": "Svalbard"
          },
          {
            "id": 205,
            "code": "SWZ",
            "code_2": "SZ",
            "description": "Swaziland"
          },
          {
            "id": 206,
            "code": "SWE",
            "code_2": "SE",
            "description": "Sweden"
          },
          {
            "id": 207,
            "code": "CHE",
            "code_2": "CH",
            "description": "Switzerland"
          },
          {
            "id": 208,
            "code": "SYR",
            "code_2": "SY",
            "description": "Syria"
          },
          {
            "id": 209,
            "code": "TWN",
            "code_2": "TW",
            "description": "Taiwan"
          },
          {
            "id": 210,
            "code": "TJK",
            "code_2": "TJ",
            "description": "Tajikistan"
          },
          {
            "id": 211,
            "code": "TZA",
            "code_2": "TZ",
            "description": "Tanzania"
          },
          {
            "id": 212,
            "code": "THA",
            "code_2": "TH",
            "description": "Thailand"
          },
          {
            "id": 213,
            "code": "GMB",
            "code_2": "GM",
            "description": "The Gambia"
          },
          {
            "id": 214,
            "code": "TGO",
            "code_2": "TG",
            "description": "Togo"
          },
          {
            "id": 215,
            "code": "TKL",
            "code_2": "TK",
            "description": "Tokelau"
          },
          {
            "id": 216,
            "code": "TON",
            "code_2": "TO",
            "description": "Tonga"
          },
          {
            "id": 217,
            "code": "TTO",
            "code_2": "TT",
            "description": "Trinidad and Tobago"
          },
          {
            "id": 218,
            "code": "TUN",
            "code_2": "TN",
            "description": "Tunisia"
          },
          {
            "id": 219,
            "code": "TUR",
            "code_2": "TR",
            "description": "Turkey"
          },
          {
            "id": 220,
            "code": "TKM",
            "code_2": "TM",
            "description": "Turkmenistan"
          },
          {
            "id": 221,
            "code": "TCA",
            "code_2": "TC",
            "description": "Turks and Caicos Islands"
          },
          {
            "id": 222,
            "code": "TUV",
            "code_2": "TV",
            "description": "Tuvalu"
          },
          {
            "id": 223,
            "code": "UGA",
            "code_2": "UG",
            "description": "Uganda"
          },
          {
            "id": 224,
            "code": "UKR",
            "code_2": "UA",
            "description": "Ukraine"
          },
          {
            "id": 225,
            "code": "ARE",
            "code_2": "AE",
            "description": "United Arab Emirates"
          },
          {
            "id": 226,
            "code": "GBR",
            "code_2": "GB",
            "description": "United Kingdom"
          },
          {
            "id": 227,
            "code": "USA",
            "code_2": "US",
            "description": "United States"
          },
          {
            "id": 228,
            "code": "UMI",
            "code_2": "UM",
            "description": "United States Minor Outlying Islands"
          },
          {
            "id": 229,
            "code": "URY",
            "code_2": "UY",
            "description": "Uruguay"
          },
          {
            "id": 230,
            "code": "UZB",
            "code_2": "UZ",
            "description": "Uzbekistan"
          },
          {
            "id": 231,
            "code": "VUT",
            "code_2": "VU",
            "description": "Vanuatu"
          },
          {
            "id": 232,
            "code": "VEN",
            "code_2": "VE",
            "description": "Venezuela"
          },
          {
            "id": 233,
            "code": "VNM",
            "code_2": "VN",
            "description": "Vietnam"
          },
          {
            "id": 234,
            "code": "VIR",
            "code_2": "VI",
            "description": "Virgin Islands"
          },
          {
            "id": 235,
            "code": "WLF",
            "code_2": "WF",
            "description": "Wallis and Futuna"
          },
          {
            "id": 236,
            "code": null,
            "code_2": "EH",
            "description": "Western Sahara"
          },
          {
            "id": 237,
            "code": "YEM",
            "code_2": "YE",
            "description": "Yemen"
          },
          {
            "id": 238,
            "code": null,
            "code_2": "YU",
            "description": "Yugoslavia"
          },
          {
            "id": 239,
            "code": "ZMB",
            "code_2": "ZM",
            "description": "Zambia"
          },
          {
            "id": 240,
            "code": "ZWE",
            "code_2": "ZW",
            "description": "Zimbabwe"
          }
        ]
      
     return response; 
}

export const getSearchDepartureHour = () => {
  const response = [
      {"code": "0000","description": "00:00"},
      {"code": "0200","description": "02:00"},
      {"code": "0400","description": "04:00"},
      {"code": "0600","description": "06:00"},
      {"code": "0800","description": "08:00"},
      {"code": "1000","description": "10:00"},
      {"code": "1200","description": "12:00"},
      {"code": "1400","description": "14:00"},
      {"code": "1600","description": "16:00"},
      {"code": "1800","description": "18:00"},
      {"code": "2000","description": "20:00"},
      {"code": "2200","description": "22:00"}
  ]
  return response; 
}

export const getSearchAdultsSelect = () => {
  const response = [
      {"code": "1","description": "1"},
      {"code": "2","description": "2"},
      {"code": "3","description": "3"},
      {"code": "4","description": "4"},
      {"code": "5","description": "5"}
  ]
  return response; 
}
export const getSearchJovenesSelect = () => {
  const response = [
      {"code": "1","description": "1"},
      {"code": "2","description": "2"},
      {"code": "3","description": "3"},
      {"code": "4","description": "4"},
      {"code": "5","description": "5"}
  ]
  return response; 
}
export const getSearchMenoresSelect = () => {
  const response = [
      {"code": "1","description": "1"},
      {"code": "2","description": "2"},
      {"code": "3","description": "3"},
      {"code": "4","description": "4"},
      {"code": "5","description": "5"}
  ]
  return response; 
}
export const getSearchMayoresSelect = () => {
  const response = [
      {"code": "1","description": "1"},
      {"code": "2","description": "2"},
      {"code": "3","description": "3"},
      {"code": "4","description": "4"},
      {"code": "5","description": "5"}
  ]
  return response; 
}
